import { useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { Box, Drawer, Button, Menu, MenuItem, ListItemIcon } from "@mui/material";
import { IconChevronDown, IconDashboard, IconLockOpen, IconUserCircle } from "@tabler/icons";

import useResponsive from "hooks/useResponsive";
import { DRAWER_WIDTH } from "components/data/constrain";

import UserDefault from "assets/images/user-default.svg";
import Scrollbar from "components//Scrollbar";
import SidebarItems from "components/layouts/adminLayout/NavItems";
import sidebarData from "components/data/sidebarData";
import useAuth from "hooks/useAuth";
import { useState } from "react";
import { imageBasePath } from "utils/imageBasePath";

const RootStyle = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up("lg")]: {
    flexShrink: 0,
    width: DRAWER_WIDTH,
  },
}));

const AccountStyle = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(2, 0.9),
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(3),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: theme.palette.primary[200],
  color: theme.palette.primary[500],
}));

export default function DashboardSidebar({ isOpenSidebar, onCloseSidebar }) {
  const { user } = useAuth();
  const isDesktop = useResponsive("up", "lg");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const imgUrl = user.image ? `${imageBasePath}/${user.image}` : UserDefault;

  const navigate = useNavigate();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleRoutes = (route) => {
    setAnchorEl(null);
    navigate(route, { replace: true });
  };

  // const { pathname } = useLocation();

  // useEffect(() => {
  //   if (isOpenSidebar) {
  //     onCloseSidebar();
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        "& .simplebar-content": {
          height: 1,
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <Box sx={{ mx: 2.5 }}>
        <AccountStyle>
          <img
            alt=""
            src={imgUrl}
            style={{
              height: 50,
              width: 50,
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />

          <Box sx={{ ml: 1, flex: 1 }}>
            <Button
              fullWidth
              disableElevation
              disableRipple
              endIcon={<IconChevronDown stroke={1.5} size={15} color="#4d4c7d" />}
              id="menu-button"
              aria-controls={open ? "admin-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleClick}
              sx={{
                padding: 0,
                justifyContent: "start",
                "&.MuiButtonBase-root:hover": {
                  bgcolor: "transparent",
                },
              }}
            >
              {user?.username}
            </Button>
            <Menu
              id="admin-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "menu-button",
              }}
            >
              <MenuItem sx={{ color: "#4d4c7d" }} onClick={() => handleRoutes("/admin/dashboard")}>
                <ListItemIcon>
                  <IconDashboard stroke={1.4} size={18} color="#4d4c7d" />
                </ListItemIcon>
                Dashboard
              </MenuItem>
              <MenuItem sx={{ color: "#4d4c7d" }} onClick={() => handleRoutes("/admin/profile")}>
                <ListItemIcon>
                  <IconUserCircle stroke={1.4} size={18} color="#4d4c7d" />
                </ListItemIcon>
                Profile
              </MenuItem>
              <MenuItem sx={{ color: "#4d4c7d" }} onClick={() => handleRoutes("/auth/change-password")}>
                <ListItemIcon>
                  <IconLockOpen stroke={1.4} size={18} color="#4d4c7d" />
                </ListItemIcon>
                Change Password
              </MenuItem>
            </Menu>

            <Box
              component="div"
              sx={{ maxWidth: 170, overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}
            >
              {user?.name}
            </Box>
          </Box>
        </AccountStyle>
      </Box>

      <SidebarItems sidebarData={sidebarData} />
    </Scrollbar>
  );

  return (
    <RootStyle sx={{ displayPrint: "none" }}>
      {!isDesktop && (
        <Drawer open={isOpenSidebar} onClose={onCloseSidebar} PaperProps={{ sx: { width: DRAWER_WIDTH } }}>
          {renderContent}
        </Drawer>
      )}

      {isDesktop && (
        <Drawer
          open
          variant="persistent"
          PaperProps={{
            sx: {
              borderRight: "1px dashed rgba(145, 158, 171, 0.24)",
              // backgroundColor: "#0b0b0b",
              width: DRAWER_WIDTH,
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </RootStyle>
  );
}
